module.exports = __webpack_public_path__ + "img/Metodo.3e80b15f.png";